import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { RouterModule, Routes } from '@angular/router'
import 'hammerjs'
import { SharedModule } from './core/modules/shared.module'
import { AppComponent } from './app.component'
import { FuseMainModule } from './main/main.module'
import { FuseSplashScreenService } from './core/services/splash-screen.service'
import { FuseConfigService } from './core/services/config.service'
import { FuseNavigationService } from './core/components/navigation/navigation.service'
import { TranslateModule } from '@ngx-translate/core'
import { AuthGuard } from './main/authentication/auth.guard'
import { AuthService } from './auth.service'
import { TokenInterceptorService } from './token-interceptor.service'
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material'
import { MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter'
import { ResourceLoadingService } from './main/services/resource-loading.service'

const appRoutes: Routes = [
  {
    path: '**',
    canActivate: [AuthGuard],
    redirectTo: 'administrations',
  },
]

export const CUSTOM_DATE_FORMAT = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD-MM-YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes),
    SharedModule,
    TranslateModule.forRoot(),
    FuseMainModule,
    MatMomentDateModule,
  ],
  providers: [
    FuseSplashScreenService,
    FuseConfigService,
    FuseNavigationService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    AuthService,
    ResourceLoadingService,
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'nl' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts